import React, { useEffect, useState } from "react";
import "../style/DropProgress.css";
import { getDropInformation } from '../controllers/CartConnectionLayer';
import { useTranslation } from 'react-i18next';

const DropProgress = () => {
    const { t } = useTranslation();
    const [width, setWidth] = useState(0);
    const [progressValue, setProgressValue] = useState(0);
    const [maxValue, setMaxValue] = useState(10);

    const progressPercentage = (progressValue / maxValue) * 100;

    useEffect(() => {
        setWidth(progressPercentage);
    }, [progressPercentage]);

    useEffect(() => {
        const fetchData = async () => {
            const returnedData = await getDropInformation();

            setProgressValue(returnedData.uses);
            setMaxValue(returnedData.max_uses);
        }
        fetchData();

        const interval = setInterval(fetchData, 150000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="progress-container">
            <div className="progress-wrapper">
                <div className="progress-bar">
                    <div
                        className="progress-fill"
                        style={{
                            width: `${width}%`,
                        }}
                    >
                        <div className="wave" style={{ left: `calc(${width}% - 10px)` }}></div>
                        <div className="wave reverse" style={{ left: `calc(${width}% - 10px)` }}></div>
                    </div>
                </div>
                {progressPercentage < 100 && 
                    <span className="progress-text">
                        {t('drop.dropProgress')}
                    </span>
                }
                {progressPercentage == 100 && 
                    <span className="progress-text">
                        {t('drop.dropDone')}
                    </span>
                }
            </div>
        </div>
    );
}

export default DropProgress;
